import formatMoney from '../formatMoney';

const updateFormControls = ({
  variant,
  qty,
  atcButton,
  atcButtonPrice,
  quantitySelector
}) => {
  if (!atcButton || !atcButtonPrice || !quantitySelector) return;

  const quantityControls = quantitySelector.querySelectorAll('button, input');

  const price = variant.price;
  quantitySelector.dataset.qtySelectorVariantPrice = price;
  atcButtonPrice.textContent = formatMoney(price * qty);

  if (variant && variant.available) {
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
  }
};

export default updateFormControls;
